module.exports = __webpack_public_path__ + "gce.logo.50336.png";


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/google/src/logo/gce.logo.png
// module id = 3708
// module chunks = 0